/**
 * Help content for the Formula tab — "How it works" with concrete examples.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

import { Help } from '../../components/help';

const CalculationHelpContent: FC = () => (
  <>
    <Help.Section title="How a group works">
      <p>
        Each <Help.Inline>group</Help.Inline> produces a score per item. Build
        the score from <Help.Inline>subformulas</Help.Inline> (small named
        building blocks), then combine them in the
        {' '}<Help.Inline>master formula</Help.Inline> at the bottom.
      </p>
    </Help.Section>

    <Help.Section title="Sliders vs Blocks">
      <p>
        <Help.Inline>Sliders</Help.Inline> mode: weighted sum of metrics. Fast
        for simple priorities.
        {' '}
        <Help.Inline>Blocks</Help.Inline> mode: arbitrary math (subformulas +
        operators). Use it when sliders aren&apos;t expressive enough.
      </p>
    </Help.Section>

    <Help.Section title="Group weight, date range, scope">
      <p>
        <Help.Inline>Weight %</Help.Inline> — how much this group counts vs
        other groups (they normalize to 100%).
        {' '}
        <Help.Inline>Date range</Help.Inline> — window the metrics are pulled
        from.
        {' '}
        <Help.Inline>Applies to</Help.Inline> — which layers
        (Paths&nbsp;/&nbsp;Landers&nbsp;/&nbsp;Offers) this formula evaluates.
      </p>
    </Help.Section>

    <Help.Section title="Examples">
      <Help.Example
        pattern="roi"
        effect="score = ROI — simple ranking by return"
      />
      <Help.Example
        pattern="quality = roi * ctr  →  master: quality / cost"
        effect="quality-weighted efficiency"
      />
      <Help.Example
        pattern="Group A (7d, 70%) + Group B (30d, 30%)"
        effect="prioritize short-term performance, soften with long-term"
      />
    </Help.Section>
  </>
);

export default CalculationHelpContent;
